export function phoneCode(countryCode) {
    let phoneCode = '';

    switch (countryCode) {
        case 'ar':
            phoneCode = '54';
            break;

        case 'at':
            phoneCode = '43';
            break;

        case 'au':
            phoneCode = '61';
            break;

        case 'be':
            phoneCode = '32';
            break;

        case 'br':
            phoneCode = '55';
            break;

        case 'ca':
            phoneCode = '1';
            break;

        case 'ch':
            phoneCode = '41';
            break;

        case 'cl':
            phoneCode = '56';
            break;

        case 'co':
            phoneCode = '57';
            break;

        case 'cr':
            phoneCode = '506';
            break;

        case 'cz':
            phoneCode = '420';
            break;

        case 'de':
            phoneCode = '49';
            break;

        case 'dk':
            phoneCode = '45';
            break;

        case 'ec':
            phoneCode = '593';
            break;

        case 'es':
            phoneCode = '34';
            break;

        case 'fi':
            phoneCode = '358';
            break;

        case 'fr':
            phoneCode = '33';
            break;

        case 'gb':
            phoneCode = '44';
            break;

        case 'gr':
            phoneCode = '30';
            break;

        case 'gt':
            phoneCode = '502';
            break;

        case 'hk':
            phoneCode = '852';
            break;

        case 'hu':
            phoneCode = '36';
            break;

        case 'id':
            phoneCode = '62';
            break;

        case 'ie':
            phoneCode = '353';
            break;

        case 'il':
            phoneCode = '972';
            break;

        case 'in':
            phoneCode = '91';
            break;

        case 'it':
            phoneCode = '39';
            break;

        case 'jp':
            phoneCode = '81';
            break;

        case 'kr':
            phoneCode = '82';
            break;

        case 'lt':
            phoneCode = '370';
            break;

        case 'lu':
            phoneCode = '352';
            break;

        case 'mx':
            phoneCode = '52';
            break;

        case 'my':
            phoneCode = '60';
            break;

        case 'nl':
            phoneCode = '31';
            break;

        case 'no':
            phoneCode = '47';
            break;

        case 'nz':
            phoneCode = '64';
            break;

        case 'pe':
            phoneCode = '51';
            break;

        case 'ph':
            phoneCode = '63';
            break;

        case 'pl':
            phoneCode = '48';
            break;

        case 'pt':
            phoneCode = '351';
            break;

        case 'ro':
            phoneCode = '40';
            break;

        case 'se':
            phoneCode = '46';
            break;

        case 'sg':
            phoneCode = '65';
            break;

        case 'sv':
            phoneCode = '503';
            break;

        case 'th':
            phoneCode = '66';
            break;

        case 'tr':
            phoneCode = '90';
            break;

        case 'tw':
            phoneCode = '886';
            break;

        case 'us':
            phoneCode = '1';
            break;

        case 'vn':
            phoneCode = '84';
            break;

        case 'za':
            phoneCode = '27';
            break;
    }

    return phoneCode;
}
